import { motion } from "framer-motion";
import { MANIFESTO } from "@/lib/site-data";

function Chapter({ item, index }) {
  return (
    <motion.div
      initial={{ opacity: 0, y: 60 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, margin: "-100px" }}
      transition={{ duration: 0.8, ease: [0.22, 1, 0.36, 1] }}
      className="relative grid md:grid-cols-12 gap-6 md:gap-10 items-start py-12 border-t border-border/60"
      data-testid={`chapter-${item.no}`}
    >
      <div className="md:col-span-4 flex items-baseline gap-4">
        <span className="font-display text-6xl md:text-8xl leading-none font-medium text-primary/20 select-none">
          {item.no}
        </span>
        <h3 className="font-display text-3xl md:text-4xl text-secondary">
          {item.title}
        </h3>
      </div>
      <div className="md:col-span-8 md:pt-8">
        <p className="text-lg md:text-xl text-foreground/75 leading-relaxed max-w-2xl">
          {item.body}
        </p>
      </div>
    </motion.div>
  );
}

export default function Manifesto() {
  return (
    <section id="journey" className="max-w-7xl mx-auto px-5 sm:px-8 py-24 md:py-36">
      <motion.div
        initial={{ opacity: 0, y: 30 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true }}
        transition={{ duration: 0.7 }}
        className="max-w-2xl mb-8"
      >
        <span className="text-xs uppercase tracking-[0.3em] text-primary font-medium">
          The Student Journey
        </span>
        <h2 className="font-display text-4xl md:text-6xl text-secondary mt-4 leading-[1.02]">
          Four chapters, from ambition to arrival.
        </h2>
      </motion.div>

      <div>
        {MANIFESTO.map((item, i) => (
          <Chapter key={item.no} item={item} index={i} />
        ))}
      </div>
    </section>
  );
}
